import React from 'react';
import { ButtonBaseProps } from '../Button';
import { useButtonClassNames } from '../Button/hooks';
import { Link, LinkProps } from '../Link';

export type ButtonRouterLinkProps = Partial<Omit<LinkProps, 'size'>> & ButtonBaseProps;

/**
 * Button used for navigating router links
 */
export const ButtonRouterLink: React.FunctionComponent<ButtonRouterLinkProps> = ({
	className,
	variant,
	size,
	isFullWidth,
	hasOnlyIcon,
	noRadius,
	ctaGroupPos,
	children,
	route,
	to,
	hasNoPaddingX,
	hasNoStyles,
	disabled,
	isLoading,
	...routerLinkProps // For passing props inherited from Link
}) => {
	const classes = useButtonClassNames(
		{
			variant,
			size,
			isFullWidth,
			hasOnlyIcon,
			noRadius,
			ctaGroupPos,
			hasNoPaddingX,
			hasNoStyles,
			disabled,
			isLoading,
		},
		className,
	);

	return (
		<Link className={classes} to={to ?? route?.externalRoute} state={route} {...routerLinkProps}>
			{children}
		</Link>
	);
};
